import {
  base_colorContentBorder,
  cta_buttonPrimaryBackground,
  cta_buttonPrimaryBackgroundHover,
  grey100,
  text_colorTextPrimary,
  text_colorTextSecondary,
  white100,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.InterruptBatchRenderer {
    .batch-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: ${spacing(4)};
      padding: ${spacing(3)};
      background-color: ${grey100};
      border-radius: 8px;
      border: 1px solid ${base_colorContentBorder};

      .batch-title {
        ${font_md};
        font-family: ${font_family_weight_medium};
        color: ${text_colorTextPrimary};
      }

      .batch-count {
        ${font_sm};
        color: ${text_colorTextSecondary};
      }
    }

    .interrupts-list {
      display: flex;
      flex-direction: column;
      gap: ${spacing(2)};
    }

    .submit-wrapper {
      margin-top: ${spacing(4)};
      padding: ${spacing(3)};
      background-color: ${grey100};
      border-radius: 8px;
      border: 1px solid ${base_colorContentBorder};
      display: flex;
      justify-content: flex-end;
      gap: ${spacing(2)};

      .submit-info {
        ${font_sm};
        color: ${text_colorTextSecondary};
        flex: 1;
        display: flex;
        align-items: center;
      }

      .submit-button {
        padding: ${spacing(2)} ${spacing(4)};
        border-radius: 6px;
        border: none;
        ${font_sm};
        font-family: ${font_family_weight_medium};
        cursor: pointer;
        transition: background-color 0.2s ease;
        background-color: ${cta_buttonPrimaryBackground};
        color: ${white100};

        &:hover:not(:disabled) {
          background-color: ${cta_buttonPrimaryBackgroundHover};
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }
`
